<template>
  <div class="leftpane-info">
    <v-row no-gutters v-if="!isLoggedIn" class="mleftpane-info leftpane-info-before-login my-2">
      <v-col cols="6" @click="goToLoginPage()" class="bottom-navigator-before-login-second d-flex justify-center align-center no-gutters">
        <v-btn class="leftpane-info-login-btn navigator-btn" rounded>
          <b>{{ $t(`label.login`) }}</b>
        </v-btn>
      </v-col>
      <v-col cols="6" @click="goToRegisterPage()" class="bottom-navigator-before-login-first d-flex justify-center align-center no-gutters">
        <v-btn class="leftpane-info-register-btn navigator-btn" rounded>
          <b>{{ $t(`label.register`) }}</b>
        </v-btn>
      </v-col>
    </v-row>
    <!--    LOGGED IN -->
    <div v-else class="leftpane-info mt-6 mb-2 leftpane-info-after-login">
      <v-row no-gutters>
        <v-col>
          <span style="text-transform: capitalize">{{ $t(`field.username`) }}:</span>
          <span style="font-weight: bolder">{{ memberInfo.memberCode }}</span>
        </v-col>
      </v-row>

      <v-row class="memberInfo" no-gutters>
        <v-col style="display: flex;align-items: center">
          <span style="text-transform: capitalize">{{ $t(`label.balance`) }}:</span>
          <span class="">{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
          <!--          <div @click="getMemberWallet()" class="refresh-balance-icon-leftPane"></div>-->
          <v-icon :class="{ 'mdi-spin-fast': isWalletLoading }" @click="getMemberWallet()" class="leftPane-walletRefresh">mdi-reload</v-icon>
        </v-col>

        <!--          <div style="display: flex;align-items: baseline">-->
        <!--           -->
        <!--          </div>-->

        <!--          <v-row style="justify-content: right;padding-right:1.5rem;" no-gutters>-->
        <!--          </v-row>-->
      </v-row>

      <v-row no-gutters>
        <!--        <v-col cols="3" class="loyalpts-icon-col"><img :src="`/static/svg/mobileMenu/leftpane-coin.svg`" alt width="40" height="40" /></v-col>-->
        <v-col>
          <span style="text-transform: capitalize">{{ $t(`label.coins`) }} :</span>
          <span class="container--fluid span-loyalPts-figure">{{ memberInfo.rewardBalance ? memberInfo.rewardBalance : 0 }}</span>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="member-level">
          <v-row no-gutters style="align-items: center">
            <span>{{ $t(`viptier.instantRebate`) }} : {{ totalRebate.unclaimed != null ? totalRebate.unclaimed : 0 }}</span>
            <!--            <v-btn @click="goToRewards" rounded x-small class="float-right-flexItem">claim</v-btn>-->
          </v-row>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="member-level">
          <span>{{ $t(`label.vipTier`) }} : {{ memberVipTierProgress }}</span>
        </v-col>
      </v-row>

      <v-row class="deposit-withdrawal-row pt-4" no-gutters>
        <v-btn @click="toDeposit()" class="deposit-btn">{{ $t(`label.deposit`) }}</v-btn>
        <v-btn @click="toWithdrawal()" class="withdrawal-btn">{{ $t(`mobileMenuTitle.withdraw`) }}</v-btn>
        <v-btn @click="toMobileAcc()" class="profile-btn">{{ $t(`label.profile`) }}</v-btn>
      </v-row>
    </div>

    <!--    <div class="left-pane-wrapper-div">-->
    <!--      <v-row no-gutters justify="center" class="mx-0">-->
    <!--        <v-col cols="12" class="download-banner">-->
    <!--          <v-btn class="bhaggo-downloadApp-btn" @click="downloadApk">{{ $t(`mobileMenuTitle.downloadApp`) }}</v-btn>-->
    <!--        </v-col>-->
    <!--      </v-row>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { ROUTE_NAME } from '@/constants/route.constants'
import { MEMBER_VIP_TIER_PROGRESS, MEMBER_WALLET } from '@/store/member.module'
import { uiHelper } from '@/util'
import { REBATE_HISTORY } from '@/store/bonus.module'
import { getYesterdayBdRangeInGmt8 } from '@/util/bd-timezone'

export default {
  name: 'appLeftpaneInfo',
  data: () => ({
    currentCurrency: uiHelper.getCurrency(),
    isWalletLoading: false
  }),
  created() {
    this.getRebateHistory()
  },
  computed: {
    // memberLevel() {
    //   return this.$store.state.member.info.group.toLocaleLowerCase().replace('level', '')
    // },
    memberVipTierProgress() {
      const level = this.$store.state.member.vipTierProgress.pairing.level_sequence
      const tierMap = {
        0: 'newMember',
        1: 'bronze',
        2: 'bronze',
        3: 'bronze',
        4: 'silver',
        5: 'gold',
        6: 'ruby',
        7: 'emerald',
        8: 'platinum',
        9: 'diamond',
        10: 'bluediamond'
      }
      const tier = tierMap[level] ?? 'newMember'
      return `${this.$t(`viptier.${tier}`)} ${this.$t(`viptier.level${level}`)}`
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    },
    totalRebate() {
      return this.$store.state.bonus.rebateHistory.totalRebate
    }
  },
  watch: {
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.getVipTierProgress()
      }
    }
  },
  methods: {
    getMemberWallet() {
      this.isWalletLoading = true
      this.$store.dispatch(MEMBER_WALLET)
      setTimeout(() => {
        this.isWalletLoading = false
      }, 600)
    },
    getRebateHistory() {
      // Bhaggo: 24h claim window — show only yesterday's BD-day unclaimed rebate
      // (never today's). Send the explicit range plus claimWindow=true so the API
      // applies the same restriction as the vipRewards claim widget. Backend gates
      // by brand, so other brands keep the full-dataset legacy behavior.
      const range = getYesterdayBdRangeInGmt8()
      let obj = {
        startTime: range.startTime,
        endTime: range.endTime,
        page: 1,
        size: 10000,
        claimWindow: true
      }
      this.$store.dispatch(`${REBATE_HISTORY}`, { obj })
    },
    getVipTierProgress() {
      this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
    },
    downloadApk() {
      uiHelper.downloadAPK()
    },
    toDeposit() {
      this.$router.push({
        name: ROUTE_NAME.DEPOSIT,
        lang: this.$route.params.lang
      })
    },
    toWithdrawal() {
      this.$router.push({
        name: ROUTE_NAME.WITHDRAWAL,
        params: { lang: this.$route.params.lang }
      })
    },
    toMobileAcc() {
      this.$router.push({
        name: ROUTE_NAME.MOBILE_ACCOUNT,
        params: { lang: this.$route.params.lang }
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang }
      })
    },
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER,
        params: { lang: this.$route.params.lang }
      })
    }
  }
}
</script>

<style lang="scss">
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.mdi-spin-fast {
  animation-name: spin;
  animation-duration: 500ms; /* 0.5 seconds */
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.leftPane-walletRefresh {
  cursor: pointer;
  margin-left: 8px;
  color: #50c878 !important;
}

.float-right-flexItem {
  margin-left: auto;
  margin-right: 12px;
  background: linear-gradient(178.24deg, rgba(255, 236, 0, 0.83) -12.14%, rgba(255, 157, 0, 0.83) 111.66%);
}
.leftpane-info {
  .leftpane-info-before-login {
    height: 65px;
    align-items: center;
    .navigator-btn {
      height: 35px;
      width: 110px;
      border-radius: 32px;
      font-size: 0.9rem;
      text-transform: capitalize;
    }
    .leftpane-info-login-btn {
      background: #efefef;
    }
    .leftpane-info-register-btn {
      background: radial-gradient(64.36% 672.4% at 35.64% 50%, #a1ac2f 0%, #757c2d 100%);
      color: #ffffff;
    }
  }

  .leftpane-info-after-login {
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    padding-left: 12px;
    color: #5c6055;

    .memberInfo {
      //height: 40px;
    }
    .member-level {
    }
    .deposit-withdrawal-row {
      justify-content: flex-start;
      margin-left: -8px;
      .deposit-btn {
        text-transform: capitalize;
        height: 33px !important;
        background: linear-gradient(360deg, #155300 -18.97%, #2ec500 150%);

        color: #ffffff;
        width: 27% !important;
        margin: 0 5px;
      }
      .withdrawal-btn {
        text-transform: capitalize;
        height: 33px !important;
        color: #000000;
        bbackground: #d9d9d9;
        width: 32% !important;
        margin: 0 5px;
      }

      .profile-btn {
        text-transform: capitalize;
        height: 33px !important;
        color: #000000;
        background: linear-gradient(178.24deg, rgba(255, 236, 0, 0.83) -12.14%, rgba(255, 157, 0, 0.83) 111.66%);
        width: 27% !important;
        margin: 0 5px;
      }
    }

    .span-balance {
      font-family: 'DM Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 42px;
      text-transform: uppercase;

      color: #000000;
    }

    .span-loyalPts {
      font-family: 'DM Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.15em;
      text-transform: uppercase;

      color: #aaaaaa;
    }
    .loyalpts-icon-col {
      padding-left: 28px;
      padding-bottom: 0;
    }
    .loyalpts-figure-col {
      padding-bottom: 0;
    }

    .row-loyalPts-figure {
      align-items: center;
      .span-loyalPts-figure {
        font-size: 24px;
        line-height: 31px;
        text-transform: uppercase;

        color: #000000;
      }
    }
  }
}
</style>
